import { Action, ClinicalConditionState } from './types'
import { getDefaultClinicalCondition } from './AppStateDefaults'

// setClinicalCondition
export const setClinicalCondition = (
    clinicalCondition: ClinicalConditionState
) => ({
    type: 'SET_CLINICAL_CONDITION',
    payload: {
        clinicalCondition,
    },
})

export const resetClinicalCondition = () => {
    const defaults = getDefaultClinicalCondition()
    return {
        type: 'RESET_CLINICAL_CONDITIONS',
        payload: {
            ...defaults,
        },
    }
}

const clinicalConditionReducer: React.Reducer<
    ClinicalConditionState,
    Action
> = (state: ClinicalConditionState, action: Action) => {
    switch (action.type) {
        case 'SET_CLINICAL_CONDITION':
            return {
                ...action.payload.clinicalCondition,
            }

        case 'RESET_CLINICAL_CONDITIONS':
            return {
                ...action.payload,
            }

        default:
            return state
    }
}

export default clinicalConditionReducer
